var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQLogoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 113,
    viewBox: "0 0 178 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9649 112.081H31.7863C14.3391 112.081 0 98.8176 0 82.534V34.6026H34.8943V112.081H34.9649ZM37.5078 112.081H36.9427V33.2237H0V32.6984H37.5078V112.081ZM0.0706297 30.0721C0.847628 14.4451 14.8336 1.96979 31.7863 1.96979H34.9649V30.0721H0.0706297ZM37.5078 30.3347H36.9427V0.525276H31.7156C23.5925 0.525276 15.1161 3.41429 9.1827 8.66706C4.37944 12.9349 4.66198 12.6723 9.60651 8.33876C15.6106 3.02034 23.4512 0.0656585 31.7156 0.0656585H37.4372V30.3347H37.5078Z",
    fill: "#A02939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.474 105.252C142.964 109.52 135.901 112.081 128.201 112.081H40.3301V79.9076C43.65 84.8321 53.9629 84.7008 53.9629 84.7008H107.011C107.929 84.7008 108.847 84.6351 109.765 84.4381L74.8005 65.6595L88.4333 43.7292L124.175 62.9018V45.699C124.175 37.032 116.617 30.0064 107.293 30.0064H84.1245H40.3301V1.90412H128.201C145.649 1.90412 159.988 15.1673 159.988 31.4509V82.2057L174.327 89.8879L160.694 111.818L148.474 105.252Z",
    fill: "#DF3C44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQLogoRed);
export default __webpack_public_path__ + "static/media/Q Logo Red.b10fed73640919bcf85147ae8e53e22f.svg";
export { ForwardRef as ReactComponent };